import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountCurrentBonus.js';
import { translation, formatMoney } from 'helpers/utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import ProgressCircularBar from 'ProgressCircularBar.js';
import ReactTooltip from 'react-tooltip';
import ModalOpacity from 'ModalOpacity.js';
import {
  fetchBonusListByFilter,
  setCurrentPage,
  manageBonus,
  fetchBonusListPending,
  fetchBonusListFulfilled,
  fetchBonusListFailure,
} from 'accountBonusActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountCurrentBonus extends Component {
  state = {
    selectedOfferId: null,
    showConfirmationModal: false,
    showInfoModal: false,
    modalTitle: '',
    modalDescription: '',
    infoModalTitle: '',
    infoModalDescription: '',
    status: '',
  };

  componentDidMount = async () => {
    const { fetchBonusListByFilter, processFrontError } = this.props;
    try {
      batch(async () => {
        await fetchBonusListByFilter({ activeTab: 'active' });
        await fetchBonusListByFilter({ activeTab: 'queue' });
      });
    } catch (error) {
      processFrontError(error, 'AccountCurrentBonus.componentDidMount');
    }
  };

  goPage = (currentPage, activeTab) => {
    const { fetchBonusListByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage, activeTab);
        fetchBonusListByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountQueueBonus.goPage');
    }
  };

  setSelectedOfferId = (selectedOfferId) => {
    this.setState((prevState) => {
      return { ...prevState, selectedOfferId };
    });
  };

  setStatus = (status) => {
    this.setState((prevState) => {
      return { ...prevState, status };
    });
  };

  setInfoModalTextElements = (infoModalTitle, infoModalDescription) => {
    this.setState((prevState) => {
      return { ...prevState, infoModalTitle, infoModalDescription };
    });
  };

  setConfirmModalTextElements = (action) => {
    let modalTitle = '';
    let modalDescription = '';
    switch (action) {
      case 'activate':
        modalTitle = translation('account_bonus_activationTitle');
        modalDescription = translation('account_bonus_confirmActivate');
        break;
      case 'cancel':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmCancel');
        break;
      case 'reject':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmReject');
        break;
    }

    this.setState((prevState) => {
      return { ...prevState, modalTitle, modalDescription };
    });
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  renderBonusActionConfirmation = (offerId, status) => {
    this.setStatus(status);
    this.setConfirmModalTextElements(status);
    this.setSelectedOfferId(offerId);
    this.toggleModal('showConfirmationModal');
  };

  bonusActionAccept = async (offerId, action) => {
    const { manageBonus } = this.props;

    try {
      await manageBonus(offerId, action);
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');

      this.setInfoModalTextElements('success', '');
    } catch (error) {
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');

      this.setInfoModalTextElements('error', translation(error));
    }
  };

  render() {
    const {
      showInfoModal,
      showConfirmationModal,
      modalTitle,
      modalDescription,
      infoModalTitle,
      infoModalDescription,
      status,
      selectedOfferId,
    } = this.state;
    const { isPending, bonus, limit, currencyCode } = this.props;

    const {
      data: activeBonusData,
      currentPage: activeBonusCurrentPage,
      isNextPageAvailable: activeBonusIsNextPageAvailable,
    } = bonus['active'];
    const {
      data: queueBonusData,
      currentPage: queueBonusCurrentPage,
      isNextPageAvailable: queueBonusIsNextPageAvailable,
    } = bonus['queue'];

    return (
      <S.AccountCurrentBonus className="account-current-bonus">
        {isPending ? (
          <Loader />
        ) : (
          <>
            <ModalOpacity
              isOpen={showConfirmationModal}
              showHeaderIcon={false}
              showHeaderTitle={false}
              toggleOpen={this.toggleModal.bind(this, 'showConfirmationModal')}
            >
              <S.ActivateModal>
                <S.Title>{modalTitle}</S.Title>
                <S.Description>{modalDescription}</S.Description>
                <S.BtnsWrapper>
                  <S.ButtonCancel onClick={this.toggleModal.bind(this, 'showConfirmationModal')}>
                    {translation('common_cancel')}
                  </S.ButtonCancel>
                  <S.ButtonAccept
                    onClick={this.bonusActionAccept.bind(this, selectedOfferId, status)}
                  >
                    {translation('common_accept')}
                  </S.ButtonAccept>
                </S.BtnsWrapper>
              </S.ActivateModal>
            </ModalOpacity>

            <ModalOpacity
              isOpen={showInfoModal}
              showHeaderIcon={false}
              showHeaderTitle={false}
              toggleOpen={this.toggleModal.bind(this, 'showInfoModal')}
            >
              <S.ModalInfo>
                <S.InfoTitle>{infoModalTitle}</S.InfoTitle>
                {infoModalDescription && (
                  <S.InfoDescription>{infoModalDescription}</S.InfoDescription>
                )}
              </S.ModalInfo>
            </ModalOpacity>

            <S.BonusList>
              <S.BonusListHeader>{translation('account_bonus_tableActive')}</S.BonusListHeader>
              <S.Table>
                <S.Thead>
                  <S.Tr>
                    <S.Th>{translation('account_bonus_name')}</S.Th>
                    <S.Th>{translation('account_bonus_validFromDate')}</S.Th>
                    <S.Th>{translation('account_bonus_validToDate')}</S.Th>
                    <S.Th>{translation('account_bonus_amount')}</S.Th>
                    <S.Th>{translation('account_bonus_totalToWager')}</S.Th>
                    <S.Th>{translation('account_bonus_leftToWager')}</S.Th>
                    <S.Th>{translation('account_bonus_wageredPercent')}</S.Th>
                    <S.Th>
                      <span className="ion ion-help-circled"></span>
                    </S.Th>
                    <S.Th>{translation('account_bonus_action')}</S.Th>
                  </S.Tr>
                </S.Thead>
                <S.Tbody>
                  {activeBonusData.length > 0 ? (
                    <>
                      {activeBonusData.map(
                        ({
                          offerName,
                          activationTime,
                          validTo,
                          maxBonusAmount,
                          totalToWager,
                          leftToWager,
                          wageredPercent,
                          wagerBonusId,
                          descriptionKey,
                        }) => {
                          return (
                            <S.Tr key={offerName}>
                              <S.Td className="td">
                                <span>{offerName}</span>
                              </S.Td>
                              <S.Td>
                                <span>{formatDate(activationTime, 'yyyy-MM-dd HH:mm')}</span>
                              </S.Td>
                              <S.Td>
                                <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(maxBonusAmount)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(totalToWager)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(leftToWager)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td className="wageredPercent">
                                <S.ProgressCircularWrapper>
                                  <ProgressCircularBar percentage={wageredPercent} />
                                </S.ProgressCircularWrapper>
                              </S.Td>
                              <S.Td>
                                <a
                                  data-tip
                                  data-for={`bonus_desc_${wagerBonusId}`}
                                  className="ion ion-help-circled"
                                ></a>
                                <ReactTooltip id={`bonus_desc_${wagerBonusId}`} type="light">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: translation(descriptionKey),
                                    }}
                                  ></span>
                                </ReactTooltip>
                              </S.Td>
                              <S.Td className="bonus-actions">
                                <S.Button
                                  className="reject"
                                  onClick={this.renderBonusActionConfirmation.bind(
                                    this,
                                    wagerBonusId,
                                    'cancel'
                                  )}
                                >
                                  {translation('common_cancel')}
                                </S.Button>
                              </S.Td>
                            </S.Tr>
                          );
                        }
                      )}
                      <S.Tr>
                        <S.Td colSpan="9" className="pagination">
                          <Pagination
                            {...{
                              currentPage: activeBonusCurrentPage,
                              limit,
                              data: activeBonusData,
                              isNextPageAvailable: activeBonusIsNextPageAvailable,
                              callback: (currentPage) => this.goPage(currentPage, 'active'),
                            }}
                          />
                        </S.Td>
                      </S.Tr>
                    </>
                  ) : (
                    <S.NoResult>
                      <S.Td colSpan="9">{translation('account_bonus_notFound')}</S.Td>
                    </S.NoResult>
                  )}
                </S.Tbody>
              </S.Table>
            </S.BonusList>

            <S.BonusList>
              <S.BonusListHeader>
                {translation('account_bonus_tableAwaitingActivation')}
              </S.BonusListHeader>
              <S.Table>
                <S.Thead>
                  <S.Tr>
                    <S.Th>{translation('account_bonus_name')}</S.Th>
                    <S.Th>{translation('account_bonus_amount')}</S.Th>
                    <S.Th>{translation('account_bonus_totalToWager')}</S.Th>
                    <S.Th>{translation('account_bonus_expiresOn')}</S.Th>
                    <S.Th>
                      <span className="ion ion-help-circled"></span>
                    </S.Th>
                    <S.Th>{translation('account_bonus_action')}</S.Th>
                  </S.Tr>
                </S.Thead>
                <S.Tbody>
                  {queueBonusData.length > 0 ? (
                    <>
                      {queueBonusData.map(
                        ({
                          offerName,
                          validTo,
                          bonusValue,
                          totalToWager,
                          offerQueueId,
                          descriptionKey,
                        }) => {
                          return (
                            <S.Tr key={offerQueueId}>
                              <S.Td className="td">
                                <span>{offerName}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(bonusValue)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(totalToWager)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                              </S.Td>
                              <S.Td>
                                <a
                                  data-tip
                                  data-for={`bonus_desc_${offerQueueId}`}
                                  className="ion ion-help-circled"
                                ></a>
                                <ReactTooltip id={`bonus_desc_${offerQueueId}`} type="light">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: translation(descriptionKey),
                                    }}
                                  ></span>
                                </ReactTooltip>
                              </S.Td>
                              <S.Td className="bonus-actions">
                                <S.Button
                                  className="reject"
                                  onClick={this.renderBonusActionConfirmation.bind(
                                    this,
                                    offerQueueId,
                                    'reject'
                                  )}
                                >
                                  {translation('account_bonus_delete')}
                                </S.Button>
                                <S.Button
                                  className="accept"
                                  onClick={this.renderBonusActionConfirmation.bind(
                                    this,
                                    offerQueueId,
                                    'activate'
                                  )}
                                >
                                  {translation('account_bonus_use')}
                                </S.Button>
                              </S.Td>
                            </S.Tr>
                          );
                        }
                      )}
                      <S.Tr>
                        <S.Td colSpan="6" className="pagination">
                          <Pagination
                            {...{
                              currentPage: queueBonusCurrentPage,
                              limit,
                              data: queueBonusData,
                              callback: (currentPage) => this.goPage(currentPage, 'queue')
                            }}
                          />
                        </S.Td>
                      </S.Tr>
                    </>
                  ) : (
                    <S.NoResult>
                      <S.Td colSpan="6">{translation('account_bonus_notFound')}</S.Td>
                    </S.NoResult>
                  )}
                </S.Tbody>
              </S.Table>
            </S.BonusList>
          </>
        )}
      </S.AccountCurrentBonus>
    );
  }
}

const mapStateToProps = (
  {
    AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
    Auth: {
      user: { currencyCode },
    },
  },
) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBonusListByFilter: bindActionCreators(fetchBonusListByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchBonusListPending: bindActionCreators(fetchBonusListPending, dispatch),
    fetchBonusListFulfilled: bindActionCreators(fetchBonusListFulfilled, dispatch),
    fetchBonusListFailure: bindActionCreators(fetchBonusListFailure, dispatch),
    manageBonus: bindActionCreators(manageBonus, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountCurrentBonus);
